import { z } from 'zod';

// Same regex as paiseString in fixed-departures.ts. Defined locally, not
// imported: fixed-departures -> itineraries -> family-breakdown would cycle.
const paiseString = z.string().regex(/^-?\d+$/, 'must be an integer paise string');

/**
 * Per-family price breakdown of an itinerary (spec 4.4). Computed on every
 * money recompute and stored on the itinerary + its published snapshot.
 * Display + allocation only: payments always run on the grand total.
 * Families sum exactly to `grandTotalPaise`; a family's rooms sum exactly to
 * its `netCostPaise`.
 */
export const FamilyPaxSummarySchema = z.object({
  adults: z.number().int(),
  children: z.number().int(),
  childrenNoBed: z.number().int(),
  infants: z.number().int(),
});
export type FamilyPaxSummary = z.infer<typeof FamilyPaxSummarySchema>;

export const FamilyBreakdownSchema = z.object({
  version: z.literal(1),
  families: z.array(
    z.object({
      groupId: z.string(),
      label: z.string().nullable(),
      paxSummary: FamilyPaxSummarySchema,
      rooms: z.array(
        z.object({
          index: z.number().int(),
          paxSummary: FamilyPaxSummarySchema,
          netCostPaise: paiseString,
        }),
      ),
      netCostPaise: paiseString,
      markupPaise: paiseString,
      discountPaise: paiseString,
      upsellPaise: paiseString,
      gstPaise: paiseString,
      tcsPaise: paiseString,
      totalPaise: paiseString,
    }),
  ),
  grandTotalPaise: paiseString,
});
export type FamilyBreakdown = z.infer<typeof FamilyBreakdownSchema>;
